import { render, staticRenderFns } from "./PurchaseStock.vue?vue&type=template&id=1bd6aef8"
import script from "./PurchaseStock.vue?vue&type=script&lang=js"
export * from "./PurchaseStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports